import axios from 'axios'
import Alpine from 'alpinejs'

document.addEventListener('alpine:init', () => {
    Alpine.data('filteredBlogContent', () => ({
        activeFilters: [],
        loading: false,
        blogCount: '',

        init () {
            this.blogCount = document.getElementById('results').childElementCount
        },

        handleFilterChange () {
            const categoriesSearchString = this.activeFilters.map(filter => {
                // Shopify's tagging url scheme expects spaces and some special characters to be replaced with -
                return filter.replaceAll(' ', '-').replaceAll('>', '-')
            }).join('+')
            let ajaxUrl = `/blogs/journal/tagged/${categoriesSearchString}`

            // Get the regular blog page when there are zero filters
            if (!categoriesSearchString) ajaxUrl = '/blogs/journal'

            axios.get(ajaxUrl)
                .then(response => {
                    const doc = new DOMParser().parseFromString(response.data, 'text/html')
                    const resultsHTML = doc.getElementById('results')
                    const currentResultsHTML = document.getElementById('results')

                    // Only replace the results html if the response is different
                    if (!currentResultsHTML.isEqualNode(resultsHTML)) {
                        document.getElementById('results')
                            .replaceWith(resultsHTML)
                        this.blogCount = resultsHTML.childElementCount

                        const resultsOffset = document.getElementById('results').offsetTop

                        if (window.scrollY > resultsOffset) {
                            window.scrollTo({
                                top: resultsOffset - 200,
                                left: 0,
                                behavior: 'auto'
                            })
                        }
                    }
                })
        }
    }))
})
